window.checkBankDetailStatus = (function ($, util) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            button: '#form-journey-next',
            checkboxSection: '.vds-checkbox',
            checkbox: '.vds-checkbox__input',
            validationMessageSection: '.vds-form__validation-message',
            formJourney: '.vds-form__group',
            errorNotification: '#bank-details-service-error'
        },
        urls: {
            validateBankDetails: '/api/sitecore/CheckBankDetailStatus/ValidateBankDetails',
            errorPage: '/error/error-page'
        },
        gtm: {
            event: {
                page: 'page',
                error: 'error-msg'
            }
        },
        css: {
            invalidCheckboxError: 'vds-checkbox--invalid',
            itemHidden: 'vds-item-hidden'
        },
        func: {
            init: function () {
                self.func.bindings();
                window.dataLayer.push({
                    event: self.gtm.event.page,
                    section: window.location.pathname,
                    journeyStep: $(self.elements.formJourney).attr('id')
                });
            },
            bindings: function () {
                $(self.elements.button).on('click', self.func.bankJourneyNextEvent);
                $(self.elements.checkbox).on('change', self.func.onCheckboxUpdate);
            },
            bankJourneyNextEvent: function (event) {
                event.preventDefault();
                let success = false;
                if ($(self.elements.checkbox).prop('checked')) {
                    $.ajax({
                        method: 'GET',
                        async: false,
                        url: self.urls.validateBankDetails,
                        success: function (data) {
                            if (data.hasValidBankDetail) {
                                success = true;
                            } else {
                                $(self.elements.errorNotification).removeClass(self.css.itemHidden);
                            }
                        }
                    });
                } else {
                    window.dataLayer.push({
                        event: self.gtm.event.error
                    });
                    $(self.elements.checkboxSection).addClass(self.css.invalidCheckboxError);
                    $(self.elements.validationMessageSection).removeClass(self.css.itemHidden);
                }
                if (success) {
                    const pathName = window.location.pathname;
                    const partnerName = pathName.concat('/', $(self.elements.formJourney).attr('id'));
                    const gtmGotoPeloton = {
                        event: 'copyMembershipNumber',
                        partnerName: partnerName
                    };

                    window.dataLayer.push(gtmGotoPeloton);

                    const redirectLink = $(self.elements.button).data('nextbuttonurl');

                    if (redirectLink.length > 0) {
                        util.func.openInNewTab(redirectLink);
                    }
                }
            },
            onCheckboxUpdate: function () {
                $(self.elements.checkboxSection).removeClass(self.css.invalidCheckboxError);
                $(self.elements.validationMessageSection).addClass(self.css.itemHidden);
                $(self.elements.errorNotification).addClass(self.css.itemHidden);
            }
        }
    };
    return {
        init: self.func.init
    };
})(jQuery, window.Utilities);

$('document').ready(function () {
    if ('bankdetails' === $('#bank-form-journey').data('feature')) {
        window.checkBankDetailStatus.init();
    }
});
